export enum ApiRoutesTransfers {
  Transfers = "transfer-admin",
}

export enum ETransferStatus {
  Current = "Current",
  Pending = "Pending",
  Closed = "Closed",
  Cancelled = "Cancelled",
}

export enum ETransferDirection {
  PickupToWarehouse = "PickupToWarehouse",
  WarehouseToPickup = "WarehouseToPickup",
}

export enum ETransferItemState {
  Picked = "Picked",
  InTransit = "InTransit",
  Dispatched = "Dispatched",
}

export enum EInventoryBoxZone {
  Pickup = "Pickup",
  Warehouse = "Warehouse",
}

export const TRANSFER_STATUS_TABS: Array<{
  label: string;
  status?: ETransferStatus;
}> = [
  { label: "All" },
  { label: "Current", status: ETransferStatus.Current },
  { label: "Pending", status: ETransferStatus.Pending },
  { label: "Closed", status: ETransferStatus.Closed },
  { label: "Cancelled", status: ETransferStatus.Cancelled },
];

// Box-to-box movements (move-to-another-box) — instant, within a single zone, no status.
export enum ApiRoutesBoxMovements {
  BoxMovements = "box-movement-admin",
}

export enum ETransferView {
  Transfers = "transfers",
  BoxMovements = "box-movements",
}

export const TRANSFER_VIEW_TABS: Array<{ label: string; view: ETransferView }> =
  [
    { label: "Zone transfers", view: ETransferView.Transfers },
    { label: "Box movements", view: ETransferView.BoxMovements },
  ];

export const BOX_MOVEMENT_ZONE_TABS: Array<{
  label: string;
  zone?: EInventoryBoxZone;
}> = [
  { label: "All" },
  { label: "Pickup zone", zone: EInventoryBoxZone.Pickup },
  { label: "Inventory zone", zone: EInventoryBoxZone.Warehouse },
];
